import BOTS_CONFIG from '@webclient/lib/const/bots';

import { UserSettingsType } from '@webclient/shared-types/auth';

const DEFAULT_SPECIFIC_USER_SETTINGS: UserSettingsType = {
  shouldSaveUploadsToKnowledgeBase: false,
  searchScope: 'web_kb',
  customStyle: {
    isUpToDate: false,
    responseStyle: '',
  },
  useCustomStyle: false,
  responseLength: 'short',
  searchMode: 'fluid',
  researchAdvancedTime: '5min',
  bot: {
    id: BOTS_CONFIG.DEFAULT_KNOWZ_AI_BOT.id,
    name: BOTS_CONFIG.DEFAULT_KNOWZ_AI_BOT.name,
    image: BOTS_CONFIG.DEFAULT_KNOWZ_AI_BOT.image,
    imagePortrait: BOTS_CONFIG.DEFAULT_KNOWZ_AI_BOT.imagePortrait,
  },
  voice: {
    speed: 1,
    type: 'alloy',
    autoplay: true,
    zonos: false,
  },
  advancedPdfIngestion: false,
};

const CONFIG = {
  DEFAULT_SPECIFIC_USER_SETTINGS,
} as const;

export default CONFIG;
